<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import type { StepperTriggerProps } from 'reka-ui'
import { reactiveOmit } from '@vueuse/core'
import { StepperTrigger, useForwardProps } from 'reka-ui'
import { cn } from '@ds/lib/utils'

const props = defineProps<StepperTriggerProps & { class?: HTMLAttributes['class'] }>()

const delegatedProps = reactiveOmit(props, 'class')

const forwarded = useForwardProps(delegatedProps)
</script>

<template>
  <StepperTrigger
    v-bind="forwarded"
    :class="cn(
      'flex flex-col items-center text-center gap-2 p-2 cursor-pointer rounded-ds-sm',
      'transition-colors duration-ds-fast ease-ds-standard',
      'focus-visible:outline-none focus-visible:shadow-ds-focus',
      'disabled:cursor-not-allowed',
      props.class,
    )"
  >
    <slot />
  </StepperTrigger>
</template>
